<script setup>
import { ref, computed } from 'vue'
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'

const props = defineProps({
  modelValue: { type: String, default: null }
})

const emit = defineEmits(['update:modelValue'])

const open = ref(false)
const search = ref('')

const categories = [
  { name: 'Flags', emojis: ['🇺🇸','🇬🇧','🇫🇷','🇩🇪','🇮🇹','🇪🇸','🇵🇹','🇧🇷','🇲🇽','🇨🇦','🇦🇺','🇯🇵','🇰🇷','🇨🇳','🇮🇳','🇷🇺','🇿🇦','🇳🇬','🇰🇪','🇪🇬','🇹🇷','🇸🇦','🇦🇪','🇮🇩','🇹🇭','🇻🇳','🇵🇭','🇲🇾','🇸🇬','🇳🇿','🇦🇷','🇨🇴','🇨🇱','🇵🇪','🇪🇨','🇺🇾','🇵🇾','🇧🇴','🇻🇪','🇨🇷','🇵🇦','🇬🇹','🇭🇳','🇸🇻','🇳🇮','🇨🇺','🇩🇴','🇭🇹','🇯🇲','🇹🇹','🇧🇸','🇧🇧','🇬🇾','🇸🇷','🇧🇿','🇳🇴','🇸🇪','🇫🇮','🇩🇰','🇮🇸','🇮🇪','🇳🇱','🇧🇪','🇨🇭','🇦🇹','🇵🇱','🇨🇿','🇸🇰','🇭🇺','🇷🇴','🇧🇬','🇭🇷','🇸🇮','🇷🇸','🇧🇦','🇲🇪','🇲🇰','🇦🇱','🇬🇷','🇨🇾','🇲🇹','🇱🇺','🇱🇮','🇲🇨','🇺🇦','🇧🇾','🇲🇩','🇬🇪','🇦🇲','🇦🇿','🇰🇿','🇺🇿','🇹🇲','🇰🇬','🇹🇯','🇦🇫','🇵🇰','🇧🇩','🇱🇰','🇳🇵','🇲🇲','🇰🇭','🇱🇦','🇲🇳','🇹🇼','🇭🇰','🇲🇴','🇮🇱','🇵🇸','🇯🇴','🇱🇧','🇸🇾','🇮🇶','🇮🇷','🇰🇼','🇶🇦','🇧🇭','🇴🇲','🇾🇪','🇲🇦','🇹🇳','🇩🇿','🇱🇾','🇸🇩','🇪🇹','🇸🇴','🇹🇿','🇺🇬','🇷🇼','🇧🇮','🇨🇩','🇨🇬','🇬🇦','🇨🇲','🇬🇭','🇨🇮','🇸🇳','🇲🇱','🇧🇫','🇳🇪','🇹🇩','🇲🇬','🇲🇿','🇿🇼','🇧🇼','🇳🇦','🇿🇲','🇲🇼','🇦🇴','🇫🇯','🇵🇬','🇼🇸','🇹🇴','🏳️','🏴','🏁','🚩','🎌','🏴‍☠️'] },
  { name: 'Nature', emojis: ['🌍','🌎','🌏','🗺️','🌋','🏔️','⛰️','🏕️','🏖️','🏝️','🏜️','🌊','🌲','🌳','🌴','🌵','🌾','🌿','☘️','🍀','🍁','🍂','🍃','🌺','🌻','🌸','🌼','🌷','💐','🐝','🦋','🐛','🐞','🐜','🦗','🕷️','🐢','🐍','🦎','🐊','🐅','🐆','🦓','🐘','🦏','🦛','🐂','🐃','🐄','🐎','🐖','🐏','🐑','🐐','🦌','🐕','🐩','🐈','🐓','🦃','🕊️','🐇','🐁','🐀','🐿️','🦔','🐾','🐉','🐲','🦕','🦖','🐳','🐋','🐬','🐟','🐠','🐡','🦈','🐙','🦑','🐚','🦀','🦞','🦐','🦭','🐧','🦅','🦆','🦢','🦉','🦩','🦜','🐸','🦥','🐨','🐼','🐻','🐻‍❄️','🦁','🐯'] },
  { name: 'Activity', emojis: ['⚽','🏀','🏈','⚾','🥎','🎾','🏐','🏉','🥏','🎱','🏓','🏸','🏒','🥍','🏏','🥅','⛳','🏹','🎣','🤿','🥊','🥋','🎽','🛹','🛷','⛸️','🥌','🎿','⛷️','🏂','🏋️','🤸','🤺','⛹️','🤾','🏄','🚣','🧗','🚴','🏇','🏆','🥇','🥈','🥉','🏅','🎖️','🎗️','🎫','🎟️','🎪','🎭','🎨','🎬','🎤','🎧','🎼','🎹','🥁','🎷','🎺','🎸','🪕','🎻','🎲','♟️','🎯','🎳'] },
  { name: 'Food', emojis: ['🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🫐','🍈','🍒','🍑','🥭','🍍','🥥','🥝','🍅','🍆','🥑','🥦','🥬','🥒','🌶️','🫑','🌽','🥕','🧄','🧅','🥔','🍠','🫘','🥜','🌰','🍞','🥐','🥖','🫓','🥨','🥯','🥞','🧇','🧀','🍖','🍗','🥩','🥓','🍔','🍟','🍕','🌭','🥪','🌮','🌯','🫔','🥙','🧆','🥚','🍳','🥘','🍲','🫕','🥣','🥗','🍿','🧈','🍱','🍘','🍙','🍚','🍛','🍜','🍝','🍠','🍢','🍣','🍤','🍥','🥮','🍡','🥟','🥠','🥡','🦀','🦞','🦐','🦑','🦪','🍦','🍧','🍨','🍩','🎂','🍰','🧁','🥧','🍫','🍬','🍭','🍮','🍯','🍼','🥛','☕','🍵','🧃','🥤','🧋','🍶','🍺','🍻','🥂','🍷','🥃','🍸','🍹','🧉','🍾','🫗'] },
  { name: 'Travel', emojis: ['🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐','🛻','🚚','🚛','🚜','🛵','🏍️','🛺','🚲','🛴','🚏','🛣️','🛤️','⛽','🚨','🚥','🚦','🚧','⚓','⛵','🛶','🚤','🛳️','⛴️','🛥️','🚢','✈️','🛩️','🛫','🛬','🪂','💺','🚁','🚟','🚠','🚡','🛰️','🚀','🛸','🏠','🏡','🏘️','🏚️','🏗️','🏢','🏬','🏣','🏤','🏥','🏦','🏨','🏪','🏫','🏩','💒','🏛️','⛪','🕌','🛕','🕍','⛩️','🕋','⛲','⛺','🌁','🌃','🏙️','🌄','🌅','🌆','🌇','🌉','🗼','🗽','🗿','🏰','🏯','🎡','🎢','🎠','⛱️','🌈'] },
  { name: 'Objects', emojis: ['💻','🖥️','🖨️','⌨️','🖱️','🖲️','💾','💿','📀','📱','📞','☎️','📟','📠','📺','📻','🎙️','📡','🔋','🔌','💡','🔦','🕯️','🧯','🛢️','💸','💵','💴','💶','💷','💰','💳','💎','⚖️','🧰','🔧','🔨','⚒️','🛠️','⛏️','🔩','⚙️','🧱','⛓️','🧲','🔫','💣','🧨','🪓','🔪','🗡️','⚔️','🛡️','🚬','⚰️','🪦','🏺','🔮','📿','🧿','💈','⚗️','🔭','🔬','🕳️','🩹','🩺','💊','💉','🩸','🧬','🦠','🧫','🧪','🌡️','🧹','🧺','🧻','🚽','🚰','🚿','🛁','🛀','🧼','🪥','🧽','🪣','🧴','🛎️','🔑','🗝️','🚪','🪑','🛋️','🛏️','🛌','🧸','🪆','🖼️','🪞','🪟','🏧','🎰'] },
  { name: 'Smileys', emojis: ['😀','😃','😄','😁','😆','😅','🤣','😂','🙂','🙃','😉','😊','😇','🥰','😍','🤩','😘','😗','😚','😙','🥲','😋','😛','😜','🤪','😝','🤑','🤗','🤭','🤫','🤔','🫡','🤐','🤨','😐','😑','😶','🫥','😏','😒','🙄','😬','🤥','😌','😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤮','🥵','🥶','🥴','😵','🤯','🤠','🥳','🥸','😎','🤓','🧐','😕','🫤','😟','🙁','☹️','😮','😯','😲','😳','🥺','🥹','😦','😧','😨','😰','😥','😢','😭','😱','😖','😣','😞','😓','😩','😫','🥱','😤','😡','😠','🤬','😈','👿','💀','☠️','💩','🤡','👹','👺','👻','👽','👾','🤖','😺','😸','😹','😻','😼','😽','🙀','😿','😾','❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❤️‍🔥','💕','💞','💓','💗','💖','💘','💝'] },
  { name: 'Symbols', emojis: ['⭐','🌟','💫','✨','⚡','🔥','💥','☀️','🌤️','⛅','🌥️','☁️','🌦️','🌧️','⛈️','🌩️','❄️','🌨️','☃️','⛄','🌬️','💨','🌪️','🌫️','🌊','💧','💦','☔','☂️','⏰','🕐','⏱️','⏲️','🔔','🔕','🎵','🎶','🔊','📣','📢','✅','❌','❓','❗','⚠️','🔴','🟠','🟡','🟢','🔵','🟣','⚫','⚪','🟤','🔶','🔷','🔸','🔹','♻️','☮️','☯️','🕉️','✝️','☪️','✡️','🔯','🕎','♈','♉','♊','♋','♌','♍','♎','♏','♐','♑','♒','♓','⛎','🆔','⚛️','🈳','🔰','♾️','💠','Ⓜ️','🅰️','🅱️','🆎','🅾️','🆘','🏳️‍🌈','🏳️‍⚧️'] },
  { name: 'People', emojis: ['👋','🤚','🖐️','✋','🖖','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','🦾','🦿','🦵','🦶','👂','🦻','👃','🧠','🫀','🫁','🦷','🦴','👀','👁️','👅','👄','👶','🧒','👦','👧','🧑','👱','👨','🧔','👩','🧓','👴','👵','🙍','🙎','🙅','🙆','💁','🙋','🧏','🙇','🤦','🤷','👮','🕵️','💂','🥷','👷','🤴','👸','👳','👲','🧕','🤵','👰','🤰','🤱','👼','🎅','🤶','🦸','🦹','🧙','🧚','🧛','🧜','🧝','🧞','🧟','💆','💇','🚶','🧍','🧎','🏃','💃','🕺','👯','🧖','🧗','🤸','🏌️','🏄','🚣','🏊','⛹️','🏋️','🚴','🤼','🤽','🤾','🤺'] },
]

const emojiNames = {
  '🇺🇸': 'united states usa america', '🇬🇧': 'united kingdom uk britain england', '🇫🇷': 'france french',
  '🇩🇪': 'germany german', '🇮🇹': 'italy italian', '🇪🇸': 'spain spanish', '🇵🇹': 'portugal portuguese',
  '🇧🇷': 'brazil brazilian', '🇲🇽': 'mexico mexican', '🇨🇦': 'canada canadian', '🇦🇺': 'australia australian',
  '🇯🇵': 'japan japanese', '🇰🇷': 'south korea korean', '🇨🇳': 'china chinese', '🇮🇳': 'india indian',
  '🇷🇺': 'russia russian', '🇿🇦': 'south africa', '🇳🇬': 'nigeria', '🇰🇪': 'kenya',
  '🇪🇬': 'egypt', '🇹🇷': 'turkey turkish', '🇸🇦': 'saudi arabia', '🇦🇪': 'united arab emirates uae dubai',
  '🇮🇩': 'indonesia', '🇹🇭': 'thailand thai', '🇻🇳': 'vietnam vietnamese', '🇵🇭': 'philippines filipino',
  '🇲🇾': 'malaysia malaysian', '🇸🇬': 'singapore', '🇳🇿': 'new zealand', '🇦🇷': 'argentina',
  '🇨🇴': 'colombia', '🇨🇱': 'chile', '🇵🇪': 'peru', '🇺🇦': 'ukraine ukrainian',
  '🇳🇴': 'norway norwegian', '🇸🇪': 'sweden swedish', '🇫🇮': 'finland finnish', '🇩🇰': 'denmark danish',
  '🇮🇸': 'iceland', '🇮🇪': 'ireland irish', '🇳🇱': 'netherlands dutch holland', '🇧🇪': 'belgium',
  '🇨🇭': 'switzerland swiss', '🇦🇹': 'austria', '🇵🇱': 'poland polish', '🇬🇷': 'greece greek',
  '🇮🇱': 'israel', '🇵🇸': 'palestine', '🇯🇴': 'jordan', '🇱🇧': 'lebanon',
  '🌍': 'earth globe africa europe world', '🌎': 'earth globe americas world', '🌏': 'earth globe asia world',
  '🗺️': 'world map', '🏔️': 'mountain snow', '⛰️': 'mountain', '🌋': 'volcano',
  '🏕️': 'camping tent', '🏖️': 'beach umbrella', '🏝️': 'island desert', '🏜️': 'desert',
  '🌊': 'wave ocean water', '🌲': 'tree evergreen pine', '🌳': 'tree deciduous', '🌴': 'palm tree tropical',
  '🔥': 'fire flame hot', '⭐': 'star', '🌟': 'star glowing', '✨': 'sparkles',
  '❤️': 'heart love red', '💚': 'green heart', '💙': 'blue heart', '💛': 'yellow heart',
  '🏠': 'house home', '🏢': 'office building', '🏭': 'factory', '🏗️': 'construction building',
  '📱': 'phone mobile', '💻': 'laptop computer', '📷': 'camera photo', '🎨': 'art palette paint',
  '🐾': 'paw prints animal', '🌾': 'rice plant grain wheat', '🌿': 'herb leaf green',
  '🦁': 'lion', '🐘': 'elephant', '🐋': 'whale', '🦈': 'shark', '🐢': 'turtle',
  '🦅': 'eagle bird', '🐧': 'penguin', '🐼': 'panda', '🐨': 'koala',
  '⚽': 'soccer football', '🏀': 'basketball', '🎯': 'target dart bullseye',
  '🏆': 'trophy champion winner', '🥇': 'gold medal first',
  '✅': 'check mark done', '❌': 'cross mark no', '⚠️': 'warning',
  '♻️': 'recycle environment', '☮️': 'peace',
}

const filteredCategories = computed(() => {
  const q = search.value.toLowerCase().trim()
  if (!q) return categories

  return categories
    .map(cat => ({
      name: cat.name,
      emojis: cat.emojis.filter(e => {
        const name = emojiNames[e] || ''
        return name.includes(q) || cat.name.toLowerCase().includes(q)
      })
    }))
    .filter(cat => cat.emojis.length > 0)
})

const selectEmoji = (emoji) => {
  emit('update:modelValue', emoji)
  open.value = false
  search.value = ''
}

const clearEmoji = () => {
  emit('update:modelValue', null)
  open.value = false
  search.value = ''
}
</script>

<template>
  <Popover v-model:open="open">
    <PopoverTrigger asChild>
      <button
        type="button"
        class="w-10 h-10 rounded-md border border-input bg-background flex items-center justify-center hover:bg-accent transition-colors cursor-pointer"
        :title="modelValue ? 'Change emoji' : 'Add emoji'"
      >
        <span v-if="modelValue" class="text-xl leading-none">{{ modelValue }}</span>
        <span v-else class="text-gray-400 text-lg leading-none">+</span>
      </button>
    </PopoverTrigger>
    <PopoverContent class="w-80 p-0" align="start" :sideOffset="8">
      <div class="p-2 border-b">
        <Input
          v-model="search"
          placeholder="Search emojis..."
          class="h-8 text-sm"
          @keydown.stop
        />
      </div>
      <div class="max-h-64 overflow-y-auto p-2">
        <template v-for="cat in filteredCategories" :key="cat.name">
          <div class="text-xs text-muted-foreground font-medium mb-1 mt-2 first:mt-0">{{ cat.name }}</div>
          <div class="grid grid-cols-7 gap-0.5">
            <button
              v-for="emoji in cat.emojis"
              :key="emoji"
              type="button"
              class="w-9 h-9 flex items-center justify-center rounded hover:bg-accent cursor-pointer text-2xl"
              @click="selectEmoji(emoji)"
            >
              {{ emoji }}
            </button>
          </div>
        </template>
        <div v-if="filteredCategories.length === 0" class="text-sm text-muted-foreground text-center py-4">
          No emojis found
        </div>
      </div>
      <div v-if="modelValue" class="border-t p-2">
        <button
          type="button"
          class="text-xs text-muted-foreground hover:text-foreground cursor-pointer"
          @click="clearEmoji"
        >
          Remove emoji
        </button>
      </div>
    </PopoverContent>
  </Popover>
</template>
